import { ComplianceRepository } from "../../repositories/ComplianceRepository";
import { ComplianceTypeEntity } from "../../entities/ComplianceTypeEntity";

export class CreateComplianceTypeUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(data: Partial<ComplianceTypeEntity>): Promise<ComplianceTypeEntity> {
    // Validation
    if (!data.compliance_type) {
      throw new Error("Compliance type is required");
    }
    if (!data.compliance_name) {
      throw new Error("Compliance name is required");
    }
    if (!data.authority) {
      throw new Error("Authority is required");
    }
    if (!data.frequency) {
      throw new Error("Frequency is required");
    }

    return await this.repository.createComplianceType(data);
  }
}

